/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
